module.exports = __webpack_public_path__ + "img/tarot.4d5c0ebd.jpg";